import { Component, ElementRef, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, take, takeUntil } from 'rxjs';
import { DropdownHelperModel } from 'src/app/admin-panel/models/helpers/dropdown-helper.model';
import { UserProfileModel } from 'src/app/admin-panel/models/system-profiles/user-profile.model';
import { AdministratorService } from 'src/app/admin-panel/services/system-profiles/administrator-service';

@Component({
  selector: 'app-add-or-edit-administrator',
  templateUrl: './add-or-edit-administrator.component.html',
  styleUrls: ['./add-or-edit-administrator.component.scss']
})
export class AddOrEditAdministratorComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public userId: string;
  public enableEdit: boolean = false;
  public pictureIsWrongFormat: boolean = false;
  public userProfileModel: UserProfileModel = new UserProfileModel();
  public filePicture: any;
  public pictureFormat: Array<string>;
  public imagePath: string = './assets/images/icons/profile-picture-placeholder.png';
  public companyItems: Array<DropdownHelperModel> = new Array<DropdownHelperModel>();
  public errorModel: { [k: string]: any } = {};
  public spinner: boolean = false
  //#endregion
  //#region Constructor
  constructor(
    private openFile: ElementRef,  
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private administratorService: AdministratorService,
    public messageService: MessageService
  ) {
    if (this.config.data != undefined && this.config.data.id) {
      this.userId = this.config.data.id
      this.enableEdit=true;
      this.getadminbyid(this.userId)
    }
    this.pictureFormat = ['image/png', 'image/jpg', 'image/jpeg'];
    this.userProfileModel = new UserProfileModel();
  }

  ngOnInit(): void {
    this.getallcompanynames();
  }
  //#endregion
  //#region Public Methods
  addadmin(model: UserProfileModel) {
    this.errorModel = {}
    this.spinner = true;
    this.administratorService.addAdmin(model, this.filePicture)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.ref.close(true)
        },
        error: errorResponse => {
          this.spinner = false;
          if (errorResponse.error.errors && errorResponse.error.errors.Email) {
            errorResponse.error.errors.Email.forEach((error: string) => {
              this.errorModel['Email'] = error;
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.CompanyId) {
            errorResponse.error.errors.CompanyId.forEach((error: string) => {
              this.errorModel['CompanyId'] = error;
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.FirstName) {
            errorResponse.error.errors.FirstName.forEach((error: string) => {
              this.errorModel['FirstName'] = error;
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.LastName) {
            errorResponse.error.errors.LastName.forEach((error: string) => {
              this.errorModel['LastName'] = error;
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.Phone) {
            errorResponse.error.errors.Phone.forEach((error: string) => {
              this.errorModel['Phone'] = error;
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.DateOfBirth) {
            errorResponse.error.errors.DateOfBirth.forEach((error: string) => {
              this.errorModel['DateOfBirth'] = error;
            });
          }
          else if (errorResponse.error) {
            this.messageService.add({ severity: 'error', summary: errorResponse.error.title, life: 2000 });
          }
        }
      });
  }
  updateAdmin(model: UserProfileModel) {
    this.errorModel = {}
    this.spinner = true;
    this.administratorService.updateAdmin(model, this.filePicture)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.ref.close(true)
        },
        error: errorResponse => {
          this.spinner = false;
          if (errorResponse.error.errors && errorResponse.error.errors.Email) {
            errorResponse.error.errors.Email.forEach((error: string) => {
              this.errorModel['Email'] = error;
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.CompanyId) {
            errorResponse.error.errors.CompanyId.forEach((error: string) => {
              this.errorModel['CompanyId'] = error;
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.FirstName) {
            errorResponse.error.errors.FirstName.forEach((error: string) => {
              this.errorModel['FirstName'] = error;
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.LastName) {
            errorResponse.error.errors.LastName.forEach((error: string) => {
              this.errorModel['LastName'] = error;
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.Phone) {
            errorResponse.error.errors.Phone.forEach((error: string) => {
              this.errorModel['Phone'] = error;
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.DateOfBirth) {
            errorResponse.error.errors.DateOfBirth.forEach((error: string) => {
              this.errorModel['DateOfBirth'] = error;
            });
          }
          else if (errorResponse.error) {
            this.messageService.add({ severity: 'error', summary: errorResponse.error.title, life: 2000 });
          }
        }
      });
  }
  cancel() {
    this.ref.close(false)
  }
  openAddImage() {
    var element = this.openFile.nativeElement.querySelector(".open-file");
    element.click();
  }
  onFileSelected(event: any) {
    this.pictureIsWrongFormat = false;
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      if (!this.pictureFormat.includes(event.target.files[0].type)) {
        this.pictureIsWrongFormat = true;
        return
      }
      let image: File = event.target.files[0]
      reader.readAsDataURL(image);// read file as data url
      // this.compressImage.compress(image)
      //   .pipe(take(1))
      //   .subscribe(compressedImage => {
      //     this.filePicture = compressedImage;
      //   })
      reader.onload = (item) => { // called once readAsDataURL is completed
        if (item.target?.result) {
          this.userProfileModel.profilePictureUrl = item.target?.result as string
        }
      }
    }
  }
  getallcompanynames() {
    this.administratorService.getAllCompanyNames()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.companyItems = response;
        },
        error: errorResponse => {

        }
      });
  }

  getadminbyid(id: string) {
    this.spinner = true;
    this.administratorService.getadminbyid(id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.userProfileModel.adminId = response.adminId;
          this.userProfileModel.firstName = response.firstName;
          this.userProfileModel.lastName = response.lastName;
          this.userProfileModel.roleName = response.roleName;
          this.userProfileModel.profilePictureUrl = response.profilePictureUrl;
          this.userProfileModel.email = response.email;
          this.userProfileModel.companyId = response.companyId;
          this.userProfileModel.phone = response.phone;
          this.userProfileModel.dateOfBirth = new Date((response.dateOfBirth as string) + "Z");

        },
        error: errorResponse => {
          this.spinner = false;
        }
      });
  }
  //#endregion
  //#Private Methods
  //#endregion
}
